import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uv-filters-range uv-filters-price" }
const _hoisted_2 = { className: "uv-range-display" }

import { TOptionValue } from "@/types";
	import { ref, computed, watch } from "vue";
	import VueSlider from 'vue-slider-component';
	import 'vue-slider-component/lib/theme/default.scss';

	type IDisplayModifierFunction = (val:number) => string; 

	
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    name: null,
    min: null,
    max: null,
    step: null,
    selectedMin: null,
    selectedMax: null,
    displayModifier: null
  },
  emits: ['change', 'drag'],
  setup(__props: any, { emit }) {

const props = __props as {
		title: string,
		name: string,
		min: number,
		max: number, 
		step: number, 
		selectedMin: number, 
		selectedMax: number,
		displayModifier?: IDisplayModifierFunction
	}

	

		

	const uiMin = ref(props.selectedMin);
	const uiMax = ref(props.selectedMax);

	const selectedValues = computed({
		get(): Array<TOptionValue>{
			return [props.selectedMin, props.selectedMax];
		},
		set(val){
			emit('change', val);
		}
	});
	const rangeDisplay = computed((): string => {
		return `${_displayModifier(uiMin.value, props.min)} - ${_displayModifier(uiMax.value, props.min)}`
	});

	const _displayModifier = props.displayModifier || function(val: number, min?: number): string {
		return val.toString();
	}

	const handleDrag = (val: Array<number>) => {
		if (val.length == 2){
			uiMin.value = val[0];
			uiMax.value = val[1];
		}
	};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(__props.title), 1),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(rangeDisplay)), 1),
      _createVNode(_unref(VueSlider), {
        modelValue: _unref(selectedValues),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValues) ? (selectedValues).value = $event : null)),
        value: _unref(selectedValues),
        min: props.min,
        max: props.max,
        "min-range": props.step,
        contained: true,
        lazy: true,
        tooltip: "none",
        onDragging: handleDrag
      }, null, 8, ["modelValue", "value", "min", "max", "min-range"])
    ])
  ]))
}
}

})